import { useMemo } from "react";
import { useStore } from "../store/globalState";
import { useSessionStore } from "../store/useSessionStore";
import {
  accentInkOnSurface,
  type BrandMeshColors,
} from "../utils/accentInkOnSurface";

/** Flat partner accent readable on `whiteView`, for props that reject gradients. */
export const useSurfaceAccent = (): string => {
  const { theme } = useStore();
  const { session } = useSessionStore();
  const { background, bodyCopy } = theme.whiteView;
  const partnerColors = session.data?.partner?.theme?.colors as
    | BrandMeshColors
    | undefined;
  return useMemo(
    () => accentInkOnSurface(partnerColors, background, bodyCopy),
    [partnerColors, background, bodyCopy],
  );
};
